import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {baseURL} from '../Constant';
import CircularProgress from '@mui/material/CircularProgress';

const FilePreviewModal = (props) => {  
  let viewerUrl = '';
  if(props.fileName) {
    const fileUrl = `${baseURL}/file/output/${props.fileName}`;    
    const encodedUrl = encodeURIComponent(fileUrl);
    viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;      
  }  

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        {'Preview File'}
        <IconButton
          aria-label="close"
          onClick={props.onClose}
          sx={{ position: 'absolute', right: 16, top: 16 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      {props.loading ? <CircularProgress style={{margin: '30px 50px 50px 50px'}} /> : <DialogContent>
        {props.fileName ? <Box sx={{ height: '600px' }}>
          <iframe
            title="PPTX Viewer"
            src={viewerUrl}
            width="100%"
            height="100%"            
          ></iframe>
        </Box>:
        <Box sx={{ height: '100px' }}>
          {props.error}
        </Box>}
      </DialogContent>}
    </Dialog>
  );
};

export default FilePreviewModal;
